import {ILayout, useLayout} from "../../core";
import {useEffect, useState} from "react";
import getVersion from "../../../../app/utils/version.ts";

const SidebarFooter = () => {
  const {config} = useLayout()
  const [ version, setVersion ] = useState<string>('')

  useEffect(() => {
    updateDOM(config)

    getVersion().then((v) => setVersion(v))
  }, [config])

  return (
    <div className='app-sidebar-footer d-flex justify-content-center text-gray-900 fs-9 flex-column-auto pt-2 pb-6 px-6' id='kt_app_sidebar_footer'>
      <span className='text-muted fw-semibold'>
        {new Date().getFullYear().toString()}&copy;
      </span>
      <p className='text-gray-800 text-hover-primary d-inline-block m-0 ms-2'>LucaGreen - {version}</p>
    </div>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export {SidebarFooter}
